{
  "home_page": {
    "header": {
      "title": "Welcome to SparkLayer"
    }
  },
  "redirect": {
    "title": "SparkLayer is now managed in {platform}",
    "description": "Click the button below to set up and manage your SparkLayer in {platform}.",
    "action": "Continue in {platform}"
  }
}
